/* eslint-disable react/prop-types */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';

export default function AlignBottom(props) {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.pullBottom)}>
        {props.children}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  pullBottom: {
    position: 'absolute',
    width: '100%',
    bottom: '0px',
  },
});
